import { AsyncPipe } from "@angular/common";
import { Component, inject } from "@angular/core";
import { UtilityProductService } from "@domain/product/monitoring/utility-product.service";
import { UtilityConfiguration } from "@domain/project/configurations/monitoring/utility-configuration";
import { Floorplan } from "@domain/project/floorplan/floorplan";
import { MonitoringProject } from "@domain/project/monitoring-project";
import { ConfiguredProductComponent } from "@project/floorplanner/floorplan-menu/fgds/configured-product/configured-product.component";
import { FloorplanProductMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/floorplan-product-menu/floorplan-product-menu.component";
import { FloorplanService } from "@project/floorplanner/floorplan.service";
import { DraggedItemType, FloorplanDragDropService } from "@utils/floorplan-drag-drop.service";
import { Observable } from "rxjs";

@Component({
  selector: "app-utility-menu",
  imports: [ConfiguredProductComponent, FloorplanProductMenuComponent, AsyncPipe],
  templateUrl: "./utility-menu.component.html",
  styleUrl: "./utility-menu.component.scss",
})
export class UtilityMenuComponent {
  private floorplanService = inject(FloorplanService);
  private dragDropService = inject(FloorplanDragDropService);
  private utilityProductService = inject(UtilityProductService);
  protected floorplan: Floorplan;
  protected readonly tooltipTextUtility: string = $localize`:@@global.utility:Utility`;
  protected readonly fallbackImageUrl = "";

  constructor() {
    this.floorplan = this.floorplanService.selectedFloorplan;
  }

  protected get utilities(): readonly UtilityConfiguration[] {
    if (this.floorplan.project instanceof MonitoringProject) {
      return this.floorplan.project.utilities;
    }
    return [];
  }

  protected addUtility(utilityConfig: UtilityConfiguration) {
    this.floorplanService.addUtility(utilityConfig);
  }

  protected addPlaceholder() {
    this.floorplanService.addUtilityPlaceholder();
  }

  protected deleteUtility(utilityConfig: UtilityConfiguration) {
    (this.floorplan.project as MonitoringProject).deleteUtility(utilityConfig);
  }

  protected drag(utilityConfig: UtilityConfiguration) {
    this.dragDropService.setDragged({ type: DraggedItemType.UTILITY, config: utilityConfig });
  }

  protected getImageUrl$(config: UtilityConfiguration): Observable<string> {
    return this.utilityProductService.resolveImageUrl(config);
  }

  protected dragPlaceholder() {
    this.dragDropService.setDragged({ type: DraggedItemType.UTILITY_PLACEHOLDER });
  }

  protected updateUtilitiesItemTextVisibility(visible: boolean) {
    this.floorplan.floorplanState.updateUtilitiesItemTextVisibility(visible);
  }
}
